<template>
  <div id="voting">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>信任投票</b></p>
    <div v-if="done || havePrevote" class="text-area">
      他のメンバーの投票を待っています．
    </div>
    <div v-else>
      <p>承認か否認を選択し，<br>投票して下さい．</p>
      <v-container fluid>
        <v-row justify="center">
          <div class="agree">
            <agreeButton v-if="voted=='agree'" v-on:pushed="setVote('agree')" label="承認" active="true" />
            <agreeButton v-else v-on:pushed="setVote('agree')" label="承認" active="false" />
          </div>

          <div class="disagree">
            <disagreeButton v-if="voted=='disagree'" v-on:pushed="setVote('disagree')" label="否認" active="true" />
            <disagreeButton v-else v-on:pushed="setVote('disagree')" label="否認" active="false" />
          </div>
        </v-row>
      </v-container>

      <div class="send-button">
        <sendButton v-if="voted=='agree'||voted=='disagree'" v-on:pushed="vote" label="投票する" active="true"/>
        <sendButton v-else label="投票する" active="false"/>
      </div>

    </div>
  </v-card>

    <div class="prevote-table"  v-if="prevotes.length > 0">
      <v-card
        class="mx-auto my-3"
        max-width="400"
        color="#DDDDFF"
      >
      <p style="color:#444499"><b>総意の形成者</b></p>
      <div class="vote-table">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr v-for="prevote in prevotes" :key="prevote.name">
                <td>{{ prevote.name }}</td>
                <td v-if="prevote.vote=='agree'" style="color:#222288">承認</td>
                <td v-else style="color:#C71585">否認</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
    </div>

    <missionMemberCard />
  </div>
</template>
<script>
import agreeButton from '@/components/gameUiComponents/AgreeButton.vue'
import disagreeButton from '@/components/gameUiComponents/DisagreeButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
import missionMemberCard from '@/components/gameComponents/cardComponents/MissionMemberCard.vue'
export default {
  name: "voting",
  plops: [],
  components: {
    sendButton,
    missionMemberCard,
    agreeButton,
    disagreeButton
  },
  data() {
    return {
      voted: '',
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      prevotes: this.$store.getters.prevotes,
      socket: this.$store.state.webSocket.socket,
      done: false,
      users: this.$store.state.userList.users
    };
  },
  computed: {
    assignedUsers() {
      return this.$store.state.missionInfo.assignedUsers
    },
    snackNum() {
      return this.$store.state.gameInfo.snackNum
    },
    havePrevote() {
      for (var i in this.users){
        if (this.users[i].id == this.userId){
          const plotCards = this.users[i].plots.filter(plot => plot.id == 3)
          if (plotCards.length > 0){
            return true
          }
        }
      }
      return false
    },
    leader() {
      return this.users.find(user => user.isLeader)
    }
  },
  methods: {
    setVote(vote){
      console.log(vote)
      this.voted = vote
    },
    vote() {
      this.$emit("send-request", {"action": "vote", "roomId": this.roomId, "userId" : this.userId, "data": {"vote": this.voted}})
      if (this.snackNum > 0){
        this.done = false
      }
    }
  },
  created() {
    this.$store.commit('setVoting')
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}

      if (res.state != "voting" && res.state != "wait-prevoting"){
        var votingUsers = []
        var snackText = "投票結果は以下です．"
        var agreeCount = 0
        for (var vote of res.data.votes){
          var votingUser = self.$store.getters.getUserById(vote.userId)
          votingUser.vote = vote.vote
          votingUsers.push(votingUser)

          snackText += "\n" + votingUser.name + "："
          if (votingUser.vote == 'agree'){
            snackText += "承認"
            agreeCount += 1
          }else {
            snackText += "否認"
          }
        }
        snackText += "\nその結果，"
        if (agreeCount > (self.users.length/2)){
          snackText += "ミッションメンバーが確定しました．"
        }else {
          snackText += "ミッションメンバーが確定しませんでした．"
          if (res.state == 'assigning-mission'){
            snackText += "リーダーが"
            var nextLeader = self.$store.getters.getUserById(res.data['next-leader'])
            snackText += nextLeader.name + "に移ります．"

            self.$store.commit('setLeader', {userId: res.data['next-leader']})
            if (self.userId == res.data['next-leader']){
              self.$store.commit('beLeader')
            }else {
              self.$store.commit('beMember')
            }
          }else if(res.state == 'game-finish') {
            snackText = "信任投票が5回否決されたため，スパイの勝利となります．"
          }
        }
        self.$emit("show-text", {state: "voting", text: snackText})
        console.log("leader:" + self.leader)
        self.$store.commit('setVotes', {'votes': votingUsers, 'assigned': self.assignedUsers, 'leader': self.leader})
        self.$store.commit('setNotVoting')

        var nextState = "voting"
        if (res.state == "voting"){
          nextState = "voting"
        }else if (res.state == "wait-decline"){
          nextState = "waitDecline"
        }else if (res.state == "wait-spotlight"){
          nextState = "waitSpotlight"
        }else if (res.state == "running-mission"){
          nextState = "runningMission"
        }else if (res.state == "wait-strong-leader"){
          nextState = "waitStrongLeader"
        }else if (res.state == "assigning-mission"){
          nextState = "assigningMission"
        }else if (res.state == "game-finish"){
          nextState = "result"
        }
        self.done = false

        self.$emit("proceed-state", nextState)
      }
      else {
        self.done = true
      }
    }
  },
}
</script>
<style>
#voting .prevote-table {
  margin-top: 12px;
}
#voting .vote-table {
  align-items: center;
  display: inline-block;
  text-align:center;
  min-width: 200px
}
#voting .assigned-table {
  margin-buttom: 12px;
}
#voting .send-button {
  padding-top: 12px;
  padding-bottom: 12px;
}
#voting .agree {
  margin-right: 12px;
  background-color: #FFFFFF
}
#voting .disagree {
  background-color: #FFFFFF
}
#voting .assigned-table {
  align-items: center;
  display: inline-block;
  text-align:center;
  min-width: 200px
}
#voting .text-area {
  width: 280px
}
</style>
